import React from 'react';
import classNames from 'classnames';
import ImageWithPlaceholder from 'src/Components/ImageWithPlaceholder';
import styles from './styles.module.scss';
import { currencyIconMap, currencyName, HeroStatus, NftItemRarity } from 'src/utils/types';
import Spinner from 'src/Components/Spinner';
import HeroTrophyIcon from 'src/Components/HeroTrophy';
import HeroLevelIcon from 'src/Components/HeroLevelV2';
import { webImageUri } from 'src/utils/uri';
import { formatCurrency, formatCurrencyInFiat } from '@wolffun/system-currency';
import HeroClassIcon from 'src/Components/HeroClassV2';
import { generateBattleStyleColor } from 'src/Pages/MarketplaceV2/Components/MarketHero/Components/SearchResult/ItemCard/utils';
import icBuy from 'assets/svg/ic_cart.svg';
import icShare from 'assets/svg/ic_share.svg';
import { getTimeSince } from 'src/utils/date';
import useCheckTradingEvent from 'src/Pages/TradingEvent/useCheckTradingEvent';
const heroRarityStyleMap = {
  [NftItemRarity.COMMON]: styles.common,
  [NftItemRarity.EPIC]: styles.epic,
  [NftItemRarity.LEGENDARY]: styles.legendary
};
const HeroCard = /*#__PURE__*/React.forwardRef(({
  className,
  hero,
  onPress
}, ref) => {
  var _hero$rentOutInfo, _hero$rentOutInfo2;

  const heroRarityClassName = heroRarityStyleMap[hero.heroRarity];
  const {
    hasEvent: hasSpecialEvent,
    heroEvent
  } = useCheckTradingEvent({
    heroTrophyClass: hero.trophy,
    heroLevel: hero.level,
    heroClass: hero.heroRole,
    skinRarity: hero.skinRarity
  });
  const isRental = hero.status === HeroStatus.FOR_RENT || hero.status === HeroStatus.RENTED || hero.status === HeroStatus.RENTED_OUT;
  const battleColor = generateBattleStyleColor(hero.battleCap, hero.battleCapMax);

  const renderStatus = () => {
    if (isRental) {
      return /*#__PURE__*/React.createElement("div", {
        className: classNames(styles.wrapStatus, styles.rent)
      }, /*#__PURE__*/React.createElement("img", {
        src: icShare,
        className: styles.icStatus
      }), /*#__PURE__*/React.createElement("span", {
        className: styles.spanStatus
      }, "Rent"));
    }

    return /*#__PURE__*/React.createElement("div", {
      className: styles.wrapStatus
    }, /*#__PURE__*/React.createElement("img", {
      src: icBuy,
      className: styles.icStatus
    }), /*#__PURE__*/React.createElement("span", {
      className: styles.spanStatus
    }, "Buy"));
  };

  const renderTradingEvent = () => {
    if (hasSpecialEvent && heroEvent) {
      return /*#__PURE__*/React.createElement("div", {
        className: styles.specialEvent
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.txtTradingEvent
      }, "Hero Trading Event"));
    }

    return null;
  };

  return /*#__PURE__*/React.createElement("div", {
    ref: ref,
    className: classNames(className, styles.container),
    onClick: onPress
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.bgCard
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.shape, styles.background)
  })), /*#__PURE__*/React.createElement("div", {
    className: styles.content
  }, /*#__PURE__*/React.createElement(ImageWithPlaceholder, {
    className: styles.portrait,
    src: webImageUri(hero.imageAvatar),
    renderPlaceholder: () => /*#__PURE__*/React.createElement(Spinner, {
      secondary: true,
      size: "50%",
      className: classNames(styles.portrait, styles.spinner)
    })
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.inner
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.itemInfo, heroRarityClassName)
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.wrapInfo
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.line, heroRarityClassName)
  }), /*#__PURE__*/React.createElement("span", {
    className: classNames(styles.tokenId, heroRarityClassName)
  }, hero.skinName), /*#__PURE__*/React.createElement("span", {
    className: styles.name
  }, hero.name.toUpperCase())), /*#__PURE__*/React.createElement("div", {
    className: styles.wrapTime
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.label
  }, "Released time"), /*#__PURE__*/React.createElement("span", {
    className: styles.value
  }, getTimeSince(new Date(hero.timestamp))))), renderTradingEvent(), /*#__PURE__*/React.createElement("div", {
    className: styles.statsItem
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.battleWrapper
  }, !isRental ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    className: styles.label
  }, "THC battle"), /*#__PURE__*/React.createElement("span", {
    className: classNames(styles.value, styles[battleColor])
  }, hero.battleCapMax - hero.battleCap, "/", hero.battleCapMax)) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    className: styles.label
  }, "Battles for rent"), !!((_hero$rentOutInfo = hero.rentOutInfo) !== null && _hero$rentOutInfo !== void 0 && _hero$rentOutInfo.rentBattles) && /*#__PURE__*/React.createElement("span", {
    className: styles.value
  }, (_hero$rentOutInfo2 = hero.rentOutInfo) === null || _hero$rentOutInfo2 === void 0 ? void 0 : _hero$rentOutInfo2.rentBattles))), /*#__PURE__*/React.createElement("div", {
    className: styles.priceWrapper
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.label
  }, "Price"), /*#__PURE__*/React.createElement("div", {
    className: styles.priceValue
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.mainWrapper
  }, hero.systemPrice && currencyIconMap[hero.systemPrice.token] && /*#__PURE__*/React.createElement("img", {
    draggable: false,
    src: currencyIconMap[hero.systemPrice.token],
    className: styles.icon
  }), hero.systemPrice && /*#__PURE__*/React.createElement("span", {
    className: styles.value
  }, formatCurrency(hero.systemPrice, {
    withCurrency: false,
    trimWholeFraction: true
  }), "\xA0", /*#__PURE__*/React.createElement("span", {
    className: styles.unit
  }, currencyName[hero.systemPrice.token]))), hero.systemPrice && /*#__PURE__*/React.createElement("span", {
    className: styles.subValue
  }, "$\xA0", formatCurrencyInFiat(hero.systemPrice, {
    withCurrency: true,
    trimWholeFraction: true
  }))))), /*#__PURE__*/React.createElement("div", {
    className: styles.heroLabel
  }, /*#__PURE__*/React.createElement(HeroTrophyIcon, {
    className: styles.trophy,
    small: true,
    value: hero.trophy
  }), /*#__PURE__*/React.createElement(HeroLevelIcon, {
    className: styles.level,
    value: hero.level
  }), /*#__PURE__*/React.createElement(HeroClassIcon, {
    value: hero.heroRole
  })), renderStatus())));
});
HeroCard.displayName = 'HeroCard';
export default HeroCard;